module.exports = __webpack_public_path__ + "static/img/noclick@2x.5e2ca9c0.png";